<!-- Sections-based menu -->
<ng-container *ngIf="menuSections">
  <ng-container *ngFor="let section of menuSections; let sectionIndex = index">
    <div *caseHasPermission="{ requireOr: section.permissionsOr }" class="menu-section">
      <p class="menu-label" *ngIf="!isCollapsed">{{ section.title }}</p>
      <hr class="menu-separator" *ngIf="isCollapsed" />
      <ul class="menu-list">
        <ng-container *ngFor="let menuItem of section.items; let i = index">
          <li *caseHasPermission="{ requireOr: menuItem.permissionsOr }">
            <!-- Direct link -->
            <ng-container *ngIf="menuItem.routePath">
              <a [routerLink]="menuItem.routePath" routerLinkActive="is-active" [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }">
                <i class="icon mr-3 is-size-4 my-0" [ngClass]="menuItem.icon"></i>
                <span class="pl-1">{{ menuItem.label }}</span>
              </a>
            </ng-container>

            <!-- Sub list -->
            <ng-container *ngIf="menuItem.items && menuItem.items.length">
              <a (click)="toggleAccordion('accordion-' + sectionIndex + '-' + i)" class="has-submenu">
                <span>
                  <i class="icon mr-3 is-size-4 my-0" [ngClass]="menuItem.icon"></i>
                  <span class="pl-1">{{ menuItem.label }}</span>
                </span>
                <i
                  class="icon icon-chevron-down mr-1"
                  *ngIf="activeAccordion !== 'accordion-' + sectionIndex + '-' + i"
                ></i>
                <i
                  class="icon icon-chevron-up mr-1"
                  *ngIf="activeAccordion === 'accordion-' + sectionIndex + '-' + i"
                ></i>
              </a>
              <ul *ngIf="activeAccordion === 'accordion-' + sectionIndex + '-' + i">
                <ng-container *ngFor="let subItem of menuItem.items">
                  <li *caseHasPermission="{ requireOr: subItem.permissionsOr }">
                    <a [routerLink]="subItem.routePath" routerLinkActive="is-active" [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }">
                      <span class="pl-1">{{ subItem.label }}</span>
                    </a>
                  </li>
                </ng-container>
              </ul>
            </ng-container>
          </li>
        </ng-container>
      </ul>
    </div>
  </ng-container>
</ng-container>

<!-- Legacy flat menu (fallback) -->
<ul class="menu-list mt-5" *ngIf="!menuSections && menuItems">
  <ng-container *ngFor="let menuItem of menuItems; let i = index">
    <li *caseHasPermission="{ requireOr: menuItem.permissionsOr }">
      <!-- Direct link -->
      <ng-container *ngIf="menuItem.routePath">
        <a [routerLink]="menuItem.routePath" routerLinkActive="is-active" [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }">
          <i class="icon mr-3 is-size-4 my-0" [ngClass]="menuItem.icon"></i>
          <span class="pl-1">{{ menuItem.label }}</span>
        </a>
      </ng-container>

      <!-- Sub list -->
      <ng-container *ngIf="menuItem.items && menuItem.items.length">
        <a (click)="toggleAccordion('accordion-' + i)" class="has-submenu">
          <span>
            <i class="icon mr-3 is-size-4 my-0" [ngClass]="menuItem.icon"></i>
            <span class="pl-1">{{ menuItem.label }}</span>
          </span>
          <i
            class="icon icon-chevron-down mr-1"
            *ngIf="activeAccordion !== 'accordion-' + i"
          ></i>
          <i
            class="icon icon-chevron-up mr-1"
            *ngIf="activeAccordion === 'accordion-' + i"
          ></i>
        </a>
        <ul *ngIf="activeAccordion === 'accordion-' + i">
          <ng-container *ngFor="let subItem of menuItem.items">
            <li *caseHasPermission="{ requireOr: subItem.permissionsOr }">
              <a [routerLink]="subItem.routePath" routerLinkActive="is-active" [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }">
                <span class="pl-1">{{ subItem.label }}</span>
              </a>
            </li>
          </ng-container>
        </ul>
      </ng-container>
    </li>
  </ng-container>
</ul>
